import styled from 'styled-components';

import Link from '~/src/common/components/Link';

export const ArticleItemContainer = styled.div`
  display: flex;
  align-items: center;

  /* 80px (picker) + 8px (margin) */
  max-width: calc(100% - 88px);
`;

export const ArticleContent = styled.div`
  margin-left: 8px;
  width: 100%;
  overflow: hidden;

  & > p {
    margin: 0;
  }

  & > p:nth-child(2) {
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.palette.common.DISABLED};
  }

  & > div:last-child {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;

    display: flex;
    align-items: center;

    & > button {
      margin-left: 8px;
    }
  }
`;

export const ArticleNameRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemLink = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
  overflow: hidden;

  &:hover {
    color: inherit;
  }
`;

export const ArticleName = styled.p<{ $isAvailable: boolean }>`
  margin: 0;

  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ReplacedTag = styled.span`
  margin-left: 8px;
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.palette.common.LIGHT_GREEN};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SubstituteButton = styled.button`
  display: flex;
  align-items: center;

  padding: 0;

  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  border: none;
  background-color: ${({ theme }) => theme.palette.common.TRANSPARENT};
  color: ${({ theme }) => theme.palette.common.PRIMARY};

  &:hover {
    color: ${({ theme }) => theme.palette.common.PRIMARY_HOVER};
  }
`;

export const NoSimilarProducts = styled.p`
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.common.DISABLED};
`;

export const ImmediatePromoPriceContainer = styled.div`
  display: flex;
  align-items: center;

  & > span:first-child {
    padding: 0 2px;

    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    background-color: ${({ theme }) => theme.palette.common.PROMOTION};
    border-radius: 4px;
  }

  & > span:last-child {
    margin-left: 4px;

    font-size: 10px;
    line-height: 16px;
    text-decoration: line-through;
  }
`;

export const BatchPromoPriceContainer = styled.div`
  display: flex;
  align-items: center;

  & > span:first-child {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
  }

  & > span:last-child {
    margin-left: 8px;
    padding: 0 4px;

    font-size: 10px;
    line-height: 16px;
    background-color: ${({ theme }) => theme.palette.common.PROMOTION};
    border-radius: 4px;
  }
`;

export const BasicItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const BasicItemCard = styled.div`
  min-width: 32px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};
`;

export const BasicIngredientName = styled.p`
  margin-left: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
`;
